import AbstractInterieur from "./AbstractInterieur";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";

export default class Kleiderstange extends AbstractInterieur {

    constructor(vsData) {
        super(vsData);
        const radius = vsData.size.y / 10 || 1;
        /* const material = {
            color: 0xd4d7dd,
            roughness: 0.1,
            metallness: 1
        }; */
        const material = UniversalLoader.getMaterialFactory().create("CHROM");
        this.stange = new THREE.Mesh(
            new THREE.CylinderGeometry(radius, radius, 100),
            material
        );
        this.stange.rotateOnAxis(new THREE.Vector3(0, 0, 1), Math.PI / 2);
        this.stange.geometry.dynamic = true;
        this.stange.castShadow = true;
        this.stange.receiveShadow = true;

        this.add(this.stange);
    }

    vsUpdate() {
        super.vsUpdate();
        if (this.isVsChanged('size')) {
            this.stange.scale.setY(this.vsData.size.x / 100);
        }
    }
}
